/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.v1.CatalogResourceChirpFrontendService
 */

export const CatalogLessonResponseTypename = 'com.hubspot.academy.catalog.models.lesson.CatalogLessonResponse';
/**
 *  This model will eventually replace {@link LessonResponseIF} once all existing usages of this model via CHIRP
 *  in other BE services have been replaced to use this model instead.
 */

export const CatalogShortFormContentResponseTypename = 'com.hubspot.academy.catalog.models.shorts.CatalogShortFormContentResponse';
export const CatalogTrackResponseTypename = 'com.hubspot.academy.catalog.models.track.CatalogTrackResponse';
/**
 *  This model will eventually replace {@link TrackResponseIF} once all existing usages of this model via CHIRP
 *  in other BE services have been replaced to use this model instead.
 */

export const getCatalogResourcesRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.v1.CatalogResourceChirpFrontendService',
  rpcName: 'getCatalogResources',
  auth: 'app',
  fingerprint: '1y9ZCdwQ6Np86D38868WGp6sAKCy2LVJ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};